import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ChartPanel from './ChartPanel/ChartPanel';
import DetailsPanel from './Details/DetailsPanel';


const MainPanel = (props) => {
    return props.data.length !== 0 
    ? props.panel === "card" 
        ? <ChartPanel {...props} /> 
        : <DetailsPanel {...props} rangeSetting={1209600} />
    : null
}

export default MainPanel;


// WEBPACK FOOTER //
// ./src/components/MainPanel.js